// src/components/PasswordRoute.js
import { useLocation, Navigate } from 'react-router-dom';
import PasswordModal from './PasswordModal'; // Assuming you have PasswordModal in the components folder

const PasswordRoute = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const seriesId = params.get('seriesId');

  if (!seriesId) {
    return <Navigate to="/404" />; // or handle as a default route
  }

  return <PasswordModal seriesId={seriesId} />;
};

export default PasswordRoute; // Make sure to export this component
